import React from "react";
import PropTypes from "prop-types";
import { useFlashMessage } from "../../hooks/useFlashMessage";
import FlashMessageView from "./FlashMessageView";

function FlashMessageContainer(props) {
    const flashProps = useFlashMessage(props);
    return <FlashMessageView {...flashProps} />;
}

export default FlashMessageContainer;

FlashMessageContainer.propTypes = {
    message: PropTypes.string,
    type: PropTypes.string,
};
